<template>
  <v-dialog
    v-if="!core.frontBanner.visible"
    v-model="core.welcomeDialog"
    scrollable
    max-width="600"
    max-height="400"
    color="primary"
    :persistent="true"
    :style="`z-index: ${core.leftBarIndex};position: fixed;`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        {{ $t("common.welcomeAndAbout.title") }}
        <v-spacer></v-spacer>

        <SwitchLanguage :app="core.app"></SwitchLanguage>
      </v-toolbar>
      <v-card-title></v-card-title>
      <v-card-text
        >{{ $t("common.welcomeAndAbout.content") }}<br /><br />{{
          $t("common.welcomeAndAbout.content_pointOne")
        }}
        <br /><br />
        {{ $t("common.welcomeAndAbout.content_pointTwo") }} <br /><br />
        {{ $t("common.welcomeAndAbout.content_pointThree") }}
      </v-card-text>
      <v-card-text v-html="$t('common.welcomeAndAbout.content_pointFour')"></v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn large color="primary" text @click="showWelcomeDialog(false)">
          {{ $t("common.ok") }}
        </v-btn>

        <v-btn large color="primary" @click="core.introVideo.visible = true">
          {{ $t("common.aboutDialog.tab_intro_video") }}
        </v-btn>
        <v-btn large color="primary" @click="showWelcomeDialog(true)">
          {{ $t("common.guidedTour") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import $ from "jquery";
import SwitchLanguage from "./SwitchLanguage.vue";
import localforage from "localforage";

export default {
  data() {
    return {
      banners: [{ img_url: "img/frontbanner/CSDI Portal_1500x500_4.png" }],
    };
  },
  mounted() {},
  props: ["core"],
  watch: {},
  computed: {},
  methods: {
    showWelcomeDialog(isShowTour) {
      this.core.welcomeDialog = false;
      //localStorage.setItem("showWelcome", false);
      localforage.setItem("showWelcome", false); //$cookies.set("showWelcome", false);

      if (isShowTour) {
        this.core.tour2.runMapTourSteps({});
      } else {
        //localStorage.setItem("showTour", false);
        localforage.setItem("showTour", false); //$cookies.set("showTour", false);
      }
    },
  },
  components: { SwitchLanguage },
};
</script>
